import {getRouteApi} from "@tanstack/react-router";

export const serviceFunctionsRouteApi = getRouteApi("/_app/engineering/services/functions/");
